import { BannerCancelledAppointment, BannerContentAppointmentReminder, BannerContentL2A, BannerContentNoShow, BannerContentOnsiteExpired, BannerContentOnsiteValid } from './content';
import { jsx as _jsx } from "react/jsx-runtime";
export function renderBannerChildren(_ref) {
  let {
    bannerProps
  } = _ref;
  switch (bannerProps.__type) {
    case 'L2A':
      return /*#__PURE__*/_jsx(BannerContentL2A, {
        ...bannerProps
      });
    case 'no-show':
      return /*#__PURE__*/_jsx(BannerContentNoShow, {
        ...bannerProps
      });
    case 'appointment-remainder':
      return /*#__PURE__*/_jsx(BannerContentAppointmentReminder, {
        ...bannerProps
      });
    case 'onsite-price-expired':
      return /*#__PURE__*/_jsx(BannerContentOnsiteExpired, {
        ...bannerProps
      });
    case 'onsite-price-valid':
      return /*#__PURE__*/_jsx(BannerContentOnsiteValid, {
        ...bannerProps
      });
    case 'canceled-appointment':
      return /*#__PURE__*/_jsx(BannerCancelledAppointment, {
        ...bannerProps
      });
    default:
      return null;
  }
}